import { PIZZA_ICONS } from "../constants/pizzaConstants";

export const getPizzaIcon = (name: string): string => {
  return PIZZA_ICONS[name] ?? "🍕";
};
